import { EuroValue, IBookingAccount } from '@dokucoach/common-types';
import { boolean, object, string } from 'yup';

export interface ICashItem {
  id: string;
  bookingAccount: IBookingAccount;
  name: string;
  priceSuggestion?: number;
  inactive: boolean;
}

export interface ICashItemInput {
  name: string;
  bookingAccountId: string;
  priceSuggestion?: number;
  inactive?: boolean;
}

export const ICashItemInputSchema = object({
  name: string().required(),
  bookingAccountId: string().required(),
  priceSuggestion: EuroValue.optional(),
  inactive: boolean().optional(),
});
